
function AdminDashboard(){
   
    return (
    <> 
      <div className="App container mt-4">
        <h1 className="mb-4">Admin Dashboard</h1>

        <div className="row">
          {/* Member Card */}
          <div className="col-md-3">
            <div className="card text-dark bg-white mb-3">
              <div className="card-body">
                <h5 className="card-title ">Total Client</h5>
                <p className="card-text fs-3">0</p>
              </div>
            </div>
          </div>

          {/* Guest Card */}
          <div className="col-md-3">
            <div className="card text-dark bg-white mb-3">
              <div className="card-body">
                <h5 className="card-title">Total Order</h5>
                <p className="card-text fs-3">0</p>
              </div>
            </div>
          </div>

          {/* Family Card */}
          <div className="col-md-3">
            <div className="card text-dark bg-white mb-3">
              <div className="card-body">
                <h5 className="card-title">New Client</h5>
                <p className="card-text fs-3">0</p>
              </div>
            </div>
          </div>

          {/* Event Card */}
          <div className="col-md-3">
            <div className="card text-dark bg-white mb-3">
              <div className="card-body">
                <h5 className="card-title">New Order</h5>
                <p className="card-text fs-3">0</p>
              </div>
            </div>
          </div>
      </div>
        </div>
    </>
  );
}


export default AdminDashboard;